// extracted by mini-css-extract-plugin
export var standaloneTable = "_dy-0";
export var standaloneTableWithBodyFill = "_dy-1";
export var withExtraHeader = "_dy-2";